import { useEffect } from 'react';

const usePostContentBlur = (active: boolean) => {
  useEffect(() => {
    const el = document.querySelector('.rendered-post') as HTMLElement | null;
    if (!el) return;

    if (active) {
      el.style.transition = 'filter 0.6s ease-out';
      el.style.filter = 'blur(4px)';
    } else {
      el.style.filter = '';
    }

    return () => {
      el.style.filter = '';
      el.style.transition = '';
    };
  }, [active]);
};

export default usePostContentBlur;
